import { render, staticRenderFns } from "./PermissionRed.vue?vue&type=template&id=99d5b392&"
import script from "./PermissionRed.vue?vue&type=script&lang=js&"
export * from "./PermissionRed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports